
// 标记状态
export const MARK_OPTIONS = [
    { label: '全部', value: '' },
    { label: '未标记', value: '0' },
    { label: '有意向', value: '1' },
    { label: '无意向', value: '2' },
    { label: '高价值', value: '3' },
    { label: '低价值', value: '4' },
    { label: '长期跟进', value: '5' },
    { label: '无效线索', value: '6' },
    { label: '未接拒接', value: '7' },
    { label: '已被接触', value: '8' },
    { label: '开场挂断', value: '9' },
    { label: '稍后联系', value: '10' }
];

export const MARK_MAP = {
    0: { text: '未标记' },
    1: { text: '有意向' },
    2: { text: '无意向' },
    3: { text: '高价值' },
    4: { text: '低价值' },
    5: { text: '长期跟进' },
    6: { text: '无效线索' },
    7: { text: '未接拒接' },
    8: { text: '已被接触' },
    9: { text: '开场挂断' },
    10: { text: '稍后联系' }
};
